import { render, staticRenderFns } from "./zy-brand.vue?vue&type=template&id=162ba6eb&scoped=true"
import script from "./zy-brand.vue?vue&type=script&lang=js"
export * from "./zy-brand.vue?vue&type=script&lang=js"
import style0 from "./zy-brand.vue?vue&type=style&index=0&id=162ba6eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162ba6eb",
  null
  
)

export default component.exports